import $ from 'jquery';
import Cookies from 'js-cookie';
import forOwn from 'lodash/forOwn';
import sortBy from 'lodash/sortBy';
import makeMoment from '../common/moment/MomentFactory';
import AlertService from '../common/alert/AlertService';
import EventService from '../common/event/EventService';
import PortalEvent from './events/PortalEvent';
import SystemListEvent from './events/SystemListEvent';
import translate from '../common/localization/translate';
import UpdateServiceEvent from './events/UpdateServiceEvent';
import VcomProvider from '../VcomProvider';
import SystemFilter from '../common/systemFilter/const/SystemFilter';
import WindowProvider from '../common/window/WindowProvider';
import AuthEvent from './events/AuthEvent';
import LicenseWarningEvent from '../../../vue3/frontend/vcom/systemlist/LicenseWarningEvent';

VcomProvider.Systems = {
  requestActive: false,
  systemsXHR: null,
  systemList: null,
};

function setUrlQueryParameter(key, value) {
  const currentUrl = new URL(WindowProvider.location.href);
  currentUrl.searchParams.set(key, value);
  WindowProvider.history.replaceState({}, '', currentUrl.href);
}

function showLicenseWarningMessage(numberOfUnlicensedSystems) {
  if (numberOfUnlicensedSystems === 0) {
    return;
  }
  $('#no-valid-license-message').html(translate('javascript.NO_VALID_SYSTEM_LICENSES_DETAIL'))
    .dialog({
      modal: true,
      resizable: false,
      height: 250,
      width: 700,
      title: translate('javascript.NO_VALID_SYSTEM_LICENSES'),
      position: { my: 'center' },
      hide: { effect: 'slide', direction: 'up' },
      show: { effect: 'slide', direction: 'up' },
      buttons: [{
        text: translate('javascript.TX_CLOSE'),
        click() {
          $(this).dialog('close');
        },
      }],
      closeText: '',
    });
}

function createUnlicensedSystemsWarning(numberOfUnlicensedSystems, showUnlicensedSystems) {
  EventService.dispatch(LicenseWarningEvent.UPDATE, {
    data: {
      numberOfUnlicensedSystems,
      show: numberOfUnlicensedSystems > 0,
      showUnlicensedSystems,
    },
  });
}

function updateSystemStatuses(systemStatuses) {
  forOwn(systemStatuses, (systemStatus, systemId) => {
    if (VcomProvider.Systems.systemList[systemId] !== undefined) {
      VcomProvider.Systems.systemList[systemId].status = systemStatus.status;
      VcomProvider.Systems.systemList[systemId].statusDateneingang = systemStatus.statusDateneingang;
    }
  });
}

function onRequestAnlagenStatusCompleted(response) {
  VcomProvider.Systems.requestActive = false;
  if (!response) {
    return;
  }
  if (response.message) {
    AlertService.showError(response.message);
    return;
  }
  updateSystemStatuses(response);
  EventService.dispatch(SystemListEvent.CHANGED, {
    data: {
      systemList: VcomProvider.Systems.systemList,
    },
  });
  VcomProvider.UpdateService.update();
}

function requestAnlagenStatus(data) {
  VcomProvider.Systems.requestActive = true;
  $.post(`${VcomProvider.baseUrl}/default/index/get-anlagen-status`, data, onRequestAnlagenStatusCompleted, 'json');
  VcomProvider.Systems.requestActive = false;
}

function requestSystems(data) {
  if (typeof data !== 'object' || data == null) {
    data = {};
  }
  VcomProvider.Systems.systemsXHR = $.ajax({
    type: 'POST',
    url: `${VcomProvider.baseUrl}/default/index/getanlagencollection`,
    dataType: 'json',
    data: JSON.stringify(data),
  }).then(function (response) {
    VcomProvider.Systems.systemList = response.systems;
    VcomProvider.installedCapacity = response.capacity;
    VcomProvider.systemFilters = data.anlagenfilter ?? VcomProvider.systemFilters;
    const filterIds = VcomProvider.systemFilters.map((filter) => filter.ID_SAF_TF_TEILMENGE);
    createUnlicensedSystemsWarning(
      response.numberOfSystemsWithInvalidLicenses,
      filterIds.includes(SystemFilter.UNLICENSED_SYSTEMS.ID_SAF_TF_TEILMENGE),
    );
    if (response.hasOnlySystemsWithInvalidLicences && VcomProvider.section === 'controlRoom') {
      showLicenseWarningMessage(response.numberOfSystemsWithInvalidLicenses);
    }
    EventService.dispatch(SystemListEvent.CHANGED, { data: { systemList: VcomProvider.Systems.systemList } });
    return VcomProvider.Systems.systemList;
  }).always(function () {
    VcomProvider.Systems.systemsXHR = null;
  });
  return VcomProvider.Systems.systemsXHR;
}

function restrictDragAndDrop() {
  const fileUploadArea = 'input-file';

  ['dragenter', 'dragover', 'drop'].forEach((eventType) => {
    window.addEventListener(eventType, function (e) {
      if ($(e.target).hasClass(fileUploadArea) === false) {
        e.preventDefault();
        e.dataTransfer.effectAllowed = 'none';
        e.dataTransfer.dropEffect = 'none';
      }
    }, false);
  });
}

function getAnlagenStatus(data) {
  if (!VcomProvider.Systems.requestActive) {
    requestAnlagenStatus(data);
  }
}

function getSystems(data) {
  if (VcomProvider.Systems.systemsXHR) {
    return VcomProvider.Systems.systemsXHR;
  }
  if (VcomProvider.Systems.systemList === null || !!data) {
    return requestSystems(data);
  }
  return $.Deferred().resolve(VcomProvider.Systems.systemList).promise();
}

function refreshTokens() {
  const tokens = Cookies.get('tokens');
  if (tokens === undefined) {
    return;
  }
  const { refreshToken } = JSON.parse(tokens);
  $.ajax({
    type: 'POST',
    url: `${VcomProvider.baseUrl}/default/login/refreshtokens`,
    data: JSON.stringify(refreshToken),
  }).done(() => {
    EventService.dispatch(AuthEvent.TOKEN_REFRESHED);
  });
}

function init() {
  VcomProvider.UpdateService.subscribe(this, 'anlagenliste');
  $('#notify-update-control .lastUpdate').html(makeMoment().format('L LTS'));

  EventService.addListener(PortalEvent.UPDATE_REQUESTED, {
    callback() {
      $('#notify-update-control .icomoon')
        .addClass('icomoon-spin icon-spinner2')
        .removeClass('icon-loop3');
    },
  });
  EventService.addListener(UpdateServiceEvent.RECEIVED, {
    callback() {
      $('#notify-update-control .icomoon')
        .removeClass('icomoon-spin icon-spinner2')
        .addClass('icon-loop3');
      $('#notify-update-control .lastUpdate').html(makeMoment().format('L LTS'));
    },
  });
  restrictDragAndDrop();
}

const Base = {
  init,
  getSystems,
  getAnlagenStatus,
  setUrlQueryParameter,
  sortSystems(systems) {
    return sortBy(systems, (system) => system.label.toLowerCase());
  },
  isDistractionFreeModeActive() {
    return localStorage.getItem('distractionFreeMode') === 'true';
  },
  refreshTokens,
};

export default Base;
